import BaseFeature from '../../foundation/base/base';


export default class HeroModule extends BaseFeature {
	constructor(element) {
		super(element);

		this.el = element;

		this.checkForSpecialHeader();
	}

	checkForSpecialHeader() {
		if (document.querySelector('.o-header--theme-light-dark-text ')) {
			this.el.classList.add('o-hero-module--dark-text');
			// this.el.querySelector('.m-link-icon--button').classList.remove('m-link-icon--button-03');
			// this.el.querySelector('.m-link-icon--button').classList.add('m-link-icon--button-02');
		}
	}
}
